import BrandsPage from "../components/BrandsPage";
import Head from "next/head";
import Metatags from "../components/Metatags";
import PropTypes from "prop-types";
import { getBrandsPage } from "../core/api/brandsPage";
import { getFooter } from "../core/api/core";
import { getMenu } from "../core/api/menu";
import { getBrandPromos } from "../core/api/brands";

export default function Brands({ data, menuData, globalData, brands }) {
  const { title } = data.wagtail.brandsPage;

  return (
    <>
      <Head>
        <title>Reskinned | {title}</title>
      </Head>
      <Metatags
        metaTitle={data.wagtail.brandsPage.metaTitle}
        metaDescription={data.wagtail.brandsPage.metaDescription}
      />
      <BrandsPage
        pageData={data.wagtail.brandsPage}
        brands={brands}
        navItems={menuData}
        globalData={globalData}
      />
    </>
  );
}

Brands.propTypes = {
  menuData: PropTypes.array.isRequired,
  globalData: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

export async function getStaticProps() {
  const { data } = await getBrandsPage();
  const menuData = await getMenu();
  const globalData = await getFooter();
  const brands = await getBrandPromos(16);

  return {
    props: {
      data,
      brands,
      menuData,
      globalData,
    },
    revalidate: 300,
  };
}
